import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IconButton, useScrollTrigger, AppBar } from 'lib/@mui';
import { Menu as MenuIcon } from 'lib/@mui/Icons';
import classNames from 'classnames';

import HideOnScroll from './HideOnScroll';
import { hasNavigationBar } from 'containers/Ezlo/utils';
import { Visibility } from '../Visibility';
import { EmailVerificationBanner } from 'components/VerificationWarningBar';

import * as Actions from '../../actions';

import styles from './Header.module.scss';
import { AppLogo } from '../../assets/icons';

const Header = (props) => {
    const { children, MainAction, threshold, headerClassName, disableHysteresis } = props;
    const hasNavigation = hasNavigationBar();

    const isAppBarEmpty = typeof children === 'undefined';
    const trigger = useScrollTrigger({
        threshold: threshold,
        disableHysteresis: disableHysteresis,
    });

    return (
        <>
            <HideOnScroll {...props}>
                <AppBar
                    className={classNames(styles.header, {
                        header_active: trigger,
                        header_empty: isAppBarEmpty,
                        [styles.full_width]: !hasNavigation,
                    })}
                >
                    <div className={styles.headerBox}>
                        {!isAppBarEmpty && (
                            <div className={classNames(styles.headerContent, headerClassName)}>
                                <div className={styles.tabletLogo}>
                                    <Visibility visible={hasNavigation}>
                                        <IconButton onClick={MainAction.showNavigation}>
                                            <MenuIcon />
                                        </IconButton>
                                    </Visibility>
                                    <AppLogo isHeader={true} />
                                </div>
                                {children}
                            </div>
                        )}
                        <EmailVerificationBanner />
                    </div>
                </AppBar>
            </HideOnScroll>
        </>
    );
};

const mapStateToProps = (state) => ({
    isShowNavigation: state.main.isShowNavigation,
});

const mapDispatchToProps = (dispatch) => {
    const obj = {};

    Object.keys(Actions).map(function (actionsName) {
        if (actionsName !== '__esModule') {
            obj[actionsName] = bindActionCreators(Actions[actionsName], dispatch);
        }
    });

    return obj;
};

Header.defaultProps = {
    threshold: 0,
    disableHysteresis: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
